import React, { FunctionComponent, useCallback, useMemo } from 'react'
import {
  ActionBar,
  Button,
  Header,
  Text,
} from '@lightspeed/design-system-react'
import { T, useT } from '@transifex/react'
import { trackUserEvent } from '@vend/utilities'
import { useRegisterManager } from '../../ng-compat/hooks'
import { WEB_REGISTER } from '../web-register.constant'
import { STATES } from '../../../../lib/routes'
import { $state } from '../../ng-compat/imports'

export const RegisterOpenReminder: FunctionComponent = () => {
  const t = useT()
  const registerManager = useRegisterManager()

  const dismissReminder = useCallback(() => {
    const activeRegister = registerManager.getActiveRegister()
    registerManager.setOpenRegisterReminderSeen({
      registerId: activeRegister.id,
      registerOpenSequenceId: activeRegister.register_open_sequence_id!,
    })
    trackUserEvent(WEB_REGISTER.APPLICATION_NAME, 'Register Open Reminder', {
      action: 'Start selling anyway',
      daysOpen: registerManager.activeRegisterDaysOpen(),
    })
  }, [registerManager])

  const viewRegisterClosure = useCallback(() => {
    trackUserEvent(WEB_REGISTER.APPLICATION_NAME, 'Register Open Reminder', {
      action: 'Close register first',
      daysOpen: registerManager.activeRegisterDaysOpen(),
    })

    $state.go(STATES.CLOSE_REGISTER)
  }, [registerManager])

  const heading = useMemo(() => {
    const count = registerManager.activeRegisterDaysOpen()
    return t(
      '{count, plural, one {This register has been open since yesterday} other {This register has been open for {count} days}}',
      { count }
    )
  }, [registerManager, t])

  return (
    <div className="register-open-reminder">
      <div className="vd-pa10">
        <Header type="heading" level="2" className="vd-mb3">
          {heading}
        </Header>
        <Text tag="p">
          <T _str="Having sales from multiple days in one register closure could create problems when you reconcile your accounts." />
        </Text>
      </div>
      <ActionBar className="vd-pl10 vd-pr10 vd-pt5 vd-pb5">
        <Button link variant="supplementary" onClick={dismissReminder}>
          <T _str="Start selling anyway" />
        </Button>
        <Button
          onClick={viewRegisterClosure}
          variant="go"
          className="vd-ml1 register-open-reminder-close"
        >
          <T _str="Close Register First" />
        </Button>
      </ActionBar>
    </div>
  )
}
